<template>
  <div class="menu-wrap">
    <div class="sidebar-header">
      <SwitchButtons v-if="false" user-level-name="Artist" />
      <div v-show="image !== null">
        <el-avatar
          shape="square"
          class="avatar"
          :src="image"
          @error="errorHandler"
          @click.native="removeImage"
          @mouseover.native="show_delete = true"
          @mouseleave.native="show_delete = false"
        >
          <img src="@/assets/images/no_image.png" />
        </el-avatar>
        <el-button
          v-if="show_delete"
          class="btn-remove"
          icon="fas fa-trash"
          circle
        ></el-button>
      </div>
      <el-upload
        v-show="image == null"
        list-type="picture-card"
        :action="`${url}user/image/upload`"
        :headers="headers"
        accept="image/*"
        :on-success="onSuccess"
        :on-error="onError"
        :on-remove="onRemove"
        :limit="1"
        ref="upload"
        :class="{ hideUpload: !showUpload, unhideUpload: showUpload }"
      >
        <div class="add-avatar" v-if="showUpload">
          <el-button icon="el-icon-plus add-light" circle></el-button>
          <p>Add photo</p>
        </div>
        <div class="thumbnail_div" slot="file" slot-scope="{ file }">
          <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
          <span class="el-upload-list__item-actions">
            <span class="el-upload-list__item-delete">
              <el-button
                icon="fas fa-trash"
                circle
                @click="onRemove"
              ></el-button>
            </span>
          </span>
        </div>
      </el-upload>
      <div class="flex-center username-box">
        <el-input
          v-if="showInput"
          class="edit-input"
          v-model="username"
        ></el-input>
        <p v-else>{{ username }}</p>
      </div>
    </div>
    <el-menu
      mode="vertical"
      text-color="#fff"
      router
      ref="sidebar"
      :default-active="$route.path"
    >
      <el-menu-item index="/artist/home">
        <img id="dashboard_img" src="@/assets/images/dashboard.svg" />
        <p>Campaigns Dashboard</p>
      </el-menu-item>
      <el-menu-item index="/artist/my-vidcents" v-if="dev === 'phase2'">
        <img id="campaigns_img" src="@/assets/images/campaigns.svg" />
        <p>Campaigns</p>
      </el-menu-item>
      <hr v-if="cid == 1"/>
      <el-menu-item index="/artist/content-id/overview" v-if="cid == 1">
        <img id="content_id_overview_img" src="@/assets/images/content_id_overview.svg" />
        <p>Content ID</p>
      </el-menu-item>
      <hr />
      <el-menu-item index="/artist/profile" v-if="dev === 'phase2'">
        <img id="my_profile_img" src="@/assets/images/my_profile.svg" />
        <p>My Profile</p>
      </el-menu-item>
      <el-menu-item index="/artist/help-desk">
        <img id="my_profile_img" src="@/assets/images/my_profile.svg" />
        <p>Help Desk</p>
      </el-menu-item>
      <el-menu-item index="/artist/vidcents-wallet" v-if="dev === 'phase2'">
        <img
          id="vidcents_wallet_img"
          src="@/assets/images/vidcents_wallet.svg"
        />
        <p>VidCents Wallet</p>
      </el-menu-item>
      <el-menu-item @click.native="artistLogout" index="/logout">
        <img id="logout_img" src="@/assets/images/logout.svg" />
        <p>Log out</p>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SwitchButtons from "@/global/components/navigation/SwitchButtons";

export default {
  data() {
    return {
      url: process.env.VUE_APP_ARTIST_API_URL,
      dev: process.env.VUE_APP_IN_DEVELOPMENT,
      showUpload: true,
      showInput: false,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      show_delete: false,
      image: null,
      username: ''
    }
  },
  components: {
    SwitchButtons
  },

  computed: {
    ...mapState('auth', ['user', 'artist']),
    ...mapState('artistDashboard', ['artist_label']),
    cid() {
      var services = this.user.services
      var ret = 0
      return ret;
    }
  },

  created() {
    this.image = this.user.image_url
    this.username = this.user.first_name + ' ' + this.user.surname
  },

  watch: {
    image(newVal, oldVal) {
      this.user.image_url = newVal
    }
  },

  methods: {
    ...mapActions('auth', ['deleteImage']),
    errorHandler() {
      return true
    },
    artistLogout() {
      this.logout('artist')
    },
    toggleUpload() {
      this.showUpload = !this.showUpload
    },

    onSuccess(response, file) {
      this.showUpload = !this.showUpload
      this.$message({
        type: 'success',
        message: `File uploaded`
      })
    },

    onError(err) {
      var res = JSON.parse(err.message)
      this.$message({
        type: 'error',
        message: res ? res.response.message : 'Upload error!'
      })
    },

    onRemove() {
      this.$confirm(
        'This action will permanently delete your profile picture?',
        'Delete',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.$message({
            type: 'info',
            message: 'Delete completed'
          })
          this.deleteImage()
          this.showUpload = true
          this.image = null
          this.$refs.upload.clearFiles()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          })
        })
    },

    removeImage() {
      if (this.show_delete) {
        this.onRemove()
      }
    },

    errorHandler() {
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.el-avatar {
  width: 100px;
  height: 100px;
}

.el-menu {
  margin-top: 10px;
  border: none;
  .el-menu-item {
    height: 50px;
    display: flex;
    align-items: center;
    margin: 0.3rem 1.5rem;
    background: transparent;
    font-size: 16px !important;
    padding-left: 25px !important;
    color: #868292 !important;
    p {
      display: flex;
      margin: 8px;
      padding-left: 12px;
      justify-content: center;
    }
    &:hover,
    &.is-active {
      background: #edecf4;
      border-radius: 11px;
      i {
        color: $--color-primary-dark;
      }
      p {
        color: $--color-secondary;
        font-weight: 500;
      }
      #music_path,
      #vc_path {
        fill: $--color-primary-dark;
      }
    }
  }
  hr {
    width: 80%;
    margin: 1rem auto;
    border: 1px solid #dedede;
  }
}
</style>
